import HomeUITable from "@/pages/AppUI/Home/show";
import HomeUiAddUpdateForm from "@/pages/AppUI/Home/AddUpdate";
import CategorySelector from "@/pages/AppUI/CategorySelector";
import withCheckPermissions from "@/layouts/GeneralLayoutWrapper/withCheckPermissions";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

export const ProtectedUIHomePage = withCheckPermissions(HomeUITable, PagesAccess.UI_HOME, OperationAccess.LIST);
export const ProtectedUIFormUpdate = withCheckPermissions(HomeUiAddUpdateForm, PagesAccess.UI_HOME, OperationAccess.UPDATE);
export const ProtectedUIFormCreate = withCheckPermissions(HomeUiAddUpdateForm, PagesAccess.UI_HOME, OperationAccess.CREATE);
export const ProtectedUICategorySelector = withCheckPermissions(
    CategorySelector,
    PagesAccess.UI_HOME,
    OperationAccess.UPDATE
);
